module.exports = __webpack_public_path__ + "res/24-img_play.1c3f23f9ccd08802be6bf0d99267891b.png";